// Shared by Snapshot dialogs whose controls change as images/options change.
function focusableElements(dialog) {
  if (!dialog) return [];
  return Array.from(dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]'))
    .filter(element => element.tabIndex >= 0 && !element.disabled &&
      !element.closest('[inert]') && element.getClientRects().length > 0 &&
      getComputedStyle(element).visibility !== 'hidden');
}

export function focusFirst(dialog) {
  const target = focusableElements(dialog)[0] || dialog;
  if (target) target.focus();
}

export function restoreFocus(element) {
  if (!element?.isConnected || element.disabled || element.closest('[inert]')) return false;
  element.focus();
  return document.activeElement === element;
}

export function trapTab(event, dialog) {
  if (event.key !== 'Tab' || !dialog) return;
  const elements = focusableElements(dialog);
  const first = elements[0];
  const last = elements[elements.length - 1];
  const active = document.activeElement;
  if (!first || !elements.includes(active) ||
      (event.shiftKey && active === first) || (!event.shiftKey && active === last)) {
    event.preventDefault();
    (event.shiftKey ? last || dialog : first || dialog).focus();
  }
}
